import { useNavigate } from "react-router-dom";

export const MAX_SEEDS = 60;

// Opens the Playlist Builder pre-seeded with these songs (live radio entries are skipped).
export const useBuildMix = () => {
  const navigate = useNavigate();
  return (tracks, extra = {}) => {
    const seeds = (tracks || []).filter((t) => t && !t.live).slice(0, MAX_SEEDS);
    if (!seeds.length && !extra.artists?.length) return;
    navigate("/builder", { state: { seeds, ...extra } });
  };
};
